export default function getAuthRedirectUrl(returnTo) {
  const { origin } = window.location;
  let result =
    `https://${
      process.env.NODE_ENV === 'development' ? 'www.sandbox' : 'www'
    }.namecheap.com` +
    `/connect/authorize` +
    `?client_id=${process.env.REACT_APP_NAMP_CLIENT_ID}` +
    `&redirect_uri=${origin}/market/login` +
    `&response_type=code` +
    `&scope=openid offline_access`;
  if (returnTo) {
    result += `&state=${returnTo}`;
  }
  return result;
}
